/** Setas ←/→ viram a página (US-03: navegação por teclado).
 *
 * Só quando o foco NÃO está num campo e não há seleção ativa — senão a seta
 * move o cursor dentro do input, ou desfaz a seleção que o aluno acabou de
 * fazer para destacar.
 */
import { useEffect } from 'react'

const CAMPOS = new Set(['INPUT', 'TEXTAREA', 'SELECT'])

function digitando(alvo: EventTarget | null): boolean {
  if (!(alvo instanceof HTMLElement)) return false
  return CAMPOS.has(alvo.tagName) || alvo.isContentEditable
}

interface Opcoes {
  onAnterior: () => void
  onProxima: () => void
  habilitado?: boolean
  /** Injetável para teste: jsdom não implementa seleção de verdade. */
  temSelecao?: () => boolean
}

export function useKeyboardNavigation({
  onAnterior,
  onProxima,
  habilitado = true,
  temSelecao = () => !(window.getSelection()?.isCollapsed ?? true),
}: Opcoes): void {
  useEffect(() => {
    if (!habilitado) return

    const onKeyDown = (evento: KeyboardEvent) => {
      if (evento.key !== 'ArrowLeft' && evento.key !== 'ArrowRight') return
      if (evento.defaultPrevented || evento.altKey || evento.ctrlKey || evento.metaKey || evento.shiftKey || evento.isComposing) return
      if (document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]')) return
      if (digitando(evento.target) || temSelecao()) return
      evento.preventDefault()
      if (evento.key === 'ArrowLeft') onAnterior()
      else onProxima()
    }

    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [habilitado, onAnterior, onProxima, temSelecao])
}
